import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="put-cross"
export default class extends Controller {
  connect() {
    console.log("putCrossController connected");
  }

  putsCross(event) {
    const inputGroup = event.target.closest(".input-group");
    const input = inputGroup.querySelector("input");
    input.value = "*";
  }
}
